import { serviceroot } from '../config';
export const changeInstallProjectType = (installProjectType) => {
    return {
        type: 'CHANGE_INSTALL_PROJECT_TYPE',
        installProjectType: installProjectType
    };
}
export const setUserWantsInstall = (installWanted) => {
    return {
        type: 'SET_INSTALL_WANTED',
        installWanted: installWanted
    };
}
export const updateInstallPostalCode = (postalCode) => {
    return ((dispatch, getState) => {
        dispatch({ type: "INIT_INSTALL_AVAILABILITY_CHECK" });
        getInstallAvalaible(postalCode).then((installAvailable) => {
            dispatch({
                type: 'SET_INSTALL_AVALAIBLE',
                installAvailable: installAvailable
            });
        });
    });        
}

export const changeCategorySelection = (categoryName, value) => {
    return {
        type: 'CHANGE_CATEGORY_SELECTION',
        categoryName,value
    };
}

export const changeInstallDescription = (installDescription) => {
    return {
        type:'CHANGE_INSTALL_DESCRIPTION',
        installDescription    
}
}
export const changeDesiredDate = (estimatedDate) => {
    return {
        type: 'CHANGE_DESIRED_DATE',
        estimatedDate
    }
}






const url =  serviceroot+ "api/install/GetInstallAvailable";
let getInstallAvalaible = async (postalNumber) => {
    const response = await fetch(url + "?postalCode=" + postalNumber);
    const result = await response.text();
    return result === "true";    

}